"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRUSTED_ISSUER = exports.METRICS_SITE_ID = exports.METRICS_CATEGORY = exports.LOG_PREFIX = exports.KEY_CODES = exports.MODAL_WIDTH = void 0;
exports.MODAL_WIDTH = 550;
exports.KEY_CODES = {
  UP: 38,
  DOWN: 40,
  ENTER: 13
};
exports.LOG_PREFIX = 'cl_';
exports.METRICS_CATEGORY = 'certificatesList';
exports.METRICS_SITE_ID = 65;
exports.TRUSTED_ISSUER = 'TRUSTED_ISSUER';